import { render, staticRenderFns } from "./orderServicerToDetail.vue?vue&type=template&id=dfe2e926&"
import script from "./orderServicerToDetail.vue?vue&type=script&lang=ts&"
export * from "./orderServicerToDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports